import React, { PropsWithChildren } from "react";
import { Stack } from "@fluentui/react/lib/Stack";

import { ITileHeaderProps } from "./ITileHeaderProps";
import { useTileHeaderStyles } from "./UseTileHeaderStyles";

export function TileHeader(props: PropsWithChildren<ITileHeaderProps>): JSX.Element {
  const { children } = props;
  const styles = useTileHeaderStyles(props);
  return (
    <Stack.Item grow={0} disableShrink className={styles.root}>
      {children}
    </Stack.Item>
  );
}
